import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../Header/Header";
import React from "react";
import Loader from "../Loader/Loader";
import { commonService } from "../../utils/commonService";
import { useSelector } from "react-redux";
import AsideRateDistribution from "./AsideRateDistribution";

const RDRoomsRatePlan = React.lazy(() => import("./RDRoomsRatePlan"));
const RDChannelManager = React.lazy(() => import("./RDChannelManager"));
const RDHistory = React.lazy(() => import("./RDHistory"));
const RDRateDistribution = React.lazy(() => import("./RDRateDistribution"));

function LayoutRateDistribution() {
    const token = commonService.getItem("token");
    const sidebarOpen = useSelector(
        (store) => store.headerProperty.isSidebarOpen
    );

    return (
        <div className={`mainRoot ${sidebarOpen ? "full-menu" : "icon-toggle-menu"}`} >
            <Header />
            <AsideRateDistribution />
            <main
                className={`config-page-body container-data-load`}
            >
                <Routes>
                    <Route
                        path="/rate-distribution"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RDRateDistribution />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/rooms-rate-plan"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RDRoomsRatePlan />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/history"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RDHistory />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                    <Route
                        path="/channel-manager"
                        element={
                            token ? (
                                <React.Suspense fallback={<Loader />}>
                                    <RDChannelManager />
                                </React.Suspense>
                            ) : (
                                <Navigate to="/" replace />
                            )
                        }
                    />
                </Routes>
            </main>
        </div>
    );
}

export default LayoutRateDistribution;